// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const handleKeyDown = (event: any, callback: () => void) => {
  if (event) {
    if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
      event.preventDefault();
      if (callback) {
        callback();
      }
    }
  }
};
